import * as React from 'react';
import { styled } from '@linaria/react';
import { ColorPath } from 'types/Theme';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { BoardType } from '@daedalus/core/src/api-types/bovio/response/booking';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  /** The type of meal/board included in the booking */
  boardType: BoardType;
  /** Board icon color */
  iconColor?: ColorPath;
}
const _exp = /*#__PURE__*/() => Grid;
const Container = /*#__PURE__*/styled(_exp())({
  name: "Container",
  class: "c1nyp3h",
  propsAsIs: true
});
export const MealName = ({
  boardType
}: Props) => {
  switch (boardType) {
    case BoardType.Breakfast:
      return <FormattedMessageWrapper id="mealType.breakfastIncluded" defaultMessage="Breakfast included" />;
    case BoardType.Lunch:
      return <FormattedMessageWrapper id="mealType.lunchIncluded" defaultMessage="Lunch included" />;
    case BoardType.Dinner:
      return <FormattedMessageWrapper id="mealType.dinnerIncluded" defaultMessage="Dinner included" />;
    case BoardType.FullBoard:
      return <FormattedMessageWrapper id="mealType.fullBoard" defaultMessage="Full board meal" />;
    case BoardType.HalfBoard:
      return <FormattedMessageWrapper id="mealType.halfBoard" defaultMessage="Half board meal" />;
    case BoardType.AllInclusive:
      return <FormattedMessageWrapper id="mealType.allInclusive" defaultMessage="All inclusive" />;
    default:
      return null;
  }
};
export const Meal = ({
  boardType,
  iconColor
}: Props) => {
  return <Container container spacing="s000" alignItems="center">
      <Icon name="Restaurant" size="sm" colorPath={iconColor ? iconColor : 'content.neutral.c600'} />
      <Text variant="bodyS" colorPath="content.neutral.c950" dataId="boardType">
        <MealName boardType={boardType} />
      </Text>
    </Container>;
};

require("./Meal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Meal.tsx");